import React, { useEffect, useState } from "react";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
import HistoricoPedidoImportacaoModalTopo from "./historicoPedidoImportacaoModalTopo";
import HistoricoPedidoImportacaoModalDetalhe from "./historicoPedidoImportacaoModalDetalhe";

import { useTranslation } from "react-i18next";

export default function HistoricoPedidoImportacaoModal(
  props: HistoricoPedidoImportacaoModalPropsTypes
) {
  const { t } = useTranslation();

  return (
    <>
      <div className="containerForecastModal" style={{ width: "80vw", height: "80vh" }}>
        <div className="containerTitleModal">
          <HistoricoPedidoImportacaoModalTopo />
        </div>
        <div className="containerToolbarModal">
          <Tooltip title={t("pages.importRequest.text.exitModal")}>
            <IconButton onClick={props.handleClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal">
          <HistoricoPedidoImportacaoModalDetalhe
            handleClose={props.handleClose}
          />
        </div>
      </div>
    </>
  );
}

interface HistoricoPedidoImportacaoModalPropsTypes {
  handleClose: any;
}
